module.exports = __webpack_public_path__ + "img/7.1213d66e.svg";